import React, { useCallback } from "react";
import { PageType, useSdkContext } from "~/components/contexts";
import { useGA4CommonParameters, useSendImpressionEvents } from "~/components/rosetta/hooks";
import { SubscriptionButton } from "~/components/rosetta/subscription-button/styles";
export const UpgradeButton = ({
  className
}) => {
  const {
    config,
    currentPageType,
    handleTrackGA4,
    handleTrackGTM,
    handleTrackMixPanel
  } = useSdkContext();
  const {
    computeGA4CommonParameters
  } = useGA4CommonParameters();
  const {
    captureTrackImpressionEventTargetElement
  } = useSendImpressionEvents({
    ga4Event: useCallback(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...computeGA4CommonParameters(),
        call_to_action: "upgrade",
        trigger_point: currentPageType === PageType.Article ? "article masthead upgrade button" : "masthead"
      },
      subcategory: "entry_point"
    }), [computeGA4CommonParameters, currentPageType]),
    gaEvent: useCallback(() => ({
      action: currentPageType === PageType.Article ? "Upgrade Entry Point/Article Page Masthead/Impression" : "Upgrade Entry Point/Masthead/Impression",
      category: "Upgrade Entry Point",
      label: window.location.href
    }), [currentPageType])
  });
  return /*#__PURE__*/React.createElement(SubscriptionButton, {
    className: className,
    ref: captureTrackImpressionEventTargetElement,
    onClick: () => {
      handleTrackMixPanel({
        name: "Subscription Entry Point",
        property: {
          Location: `${currentPageType === PageType.Article ? "Article" : "Homepage"} Masthead`
        }
      });
      const gaEvent = {
        action: `Upgrade Entry Point/${currentPageType === PageType.Article ? "Article Page Masthead" : "Masthead"}/Click`,
        category: "Upgrade Entry Point",
        label: window.location.href
      };
      handleTrackGTM({
        event: "upgrade-button",
        tracking: gaEvent
      });
      handleTrackGA4({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...computeGA4CommonParameters(),
          call_to_action: "upgrade",
          trigger_point: currentPageType === PageType.Article ? "article masthead upgrade button" : "masthead"
        },
        subcategory: "entry_point"
      });
      window.location.href = `${config.accounts.host}/manage/subscription?upgrade=true`;
      window.postMessage({
        type: "PIANO_UPGRADE_POPUP"
      }, "*");
    },
    "data-qa": "upgrade-button"
  }, "Upgrade & Save");
};
UpgradeButton.displayName = "UpgradeButton";